import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['SC', 'Susana C.', 'Buenos Aires', '4 años hinchada sin saber por qué. A los 10 días de seguir el protocolo pude abotonarme el jean de siempre.'], ['RM', 'Rosa M.', 'Córdoba', 'Los gases y el dolor bajaron en la primera semana. Todo con alimentos del super de la esquina, sin suplementos raros.'], ['EP', 'Elena P.', 'Rosario', 'El plan de 7 días me ordenó la cabeza. Por fin supe qué desayunar sin terminar inflamada al mediodía.']] as const;
const extended = [['Susana C.', 'Buenos Aires', '“4 años con la panza dura todos los días. Al ordenar los horarios y espaciar las comidas, la hinchazón empezó a ceder. Lloré de alivio.”'], ['Rosa M.', 'Córdoba', '“Lo hice junto a mi marido y en dos semanas los gases se cortaron. La tabla de reintroducción fue clave.”'], ['Elena P.', 'Rosario', '“Dejé de improvisar. En la consulta la gastroenteróloga me dijo que era la primera vez que alguien llegaba con un registro tan claro.”'], ['Marcela F.', 'Mendoza', '“Soy enfermera y empecé escéptica. Al día 9 la distensión después de comer casi había desaparecido.”'], ['Laura G.', 'Santa Fe', '“No sabía que el ajo y la cebolla me estaban arruinando el día. Ahora sé qué reemplazar y sigo comiendo rico.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-165" data-mp="249s4tyw7y7d2">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-166" data-mp="29221dxrua5ob" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+180', 'personas ya desinflamaron su digestión'], ['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-167" data-mp="mya83nwe6fds">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-168" data-mp="iy9m9i6yr1wp">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-169" data-mp="wpn32odhllo1">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-170" data-mp="ryeu1tg2k2be">
                {value}
              </p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-171" data-mp="16m9n5axzo8p0">
                {label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-172" data-mp="1fnzdsek1r3lq">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-173" data-mp="1fld5gcpc0k2g">
          {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-174" data-mp="3hg5exanckilo" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-175" data-mp="1n6ql2uj7ltuy">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-176" data-mp="1n55m8spv3ora">
                  {initials}
                </div>
                <div data-id="element-177" data-mp="1e7vcxcwlu9p0">
                  <h3 className="font-bold" data-id="element-178" data-mp="106sncq6eih9c">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-179" data-mp="10840vhpnf3dn">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-180" data-mp="148wbofe65gc1">
                <Stars data-id="element-181" data-mp="2uktx463hooo7" />
              </div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-182" data-mp="2ulv6850y313a">
                “{quote}”
              </p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-183" data-mp="29teu5lxy5lr3">
      <div className="mx-auto max-w-5xl" data-id="element-184" data-mp="24ulfhq6xbopc">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-185" data-mp="1zwsd788qreuc">
          LO QUE DICEN LAS PERSONAS QUE YA LO TIENEN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-186" data-mp="1qwww6msi8pme">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-187" data-mp="1m66p954fkepl">
              <Stars data-id="element-188" data-mp="1m4c53t0zgqmk" />
              <p className="mt-2 font-bold" data-id="element-189" data-mp="1h6u54s4y1lqp">
                {name}{' '}
                <span className="font-normal text-slate-400" data-id="element-190" data-mp="1h4r65iltci9u">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-191" data-mp="1c5wf5tdoznen">
                {quote}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}